import { ENV_CONFIGURATION_LOADED } from '../actions/settings';

const envConfiguration = (state = null, action = undefined) => {
    if (action.type === ENV_CONFIGURATION_LOADED) {
        return { ...action.payload };
    }
    return state;
};

export default envConfiguration;
